export abstract class AbsDatiUtente{
    private nome!:string
    private cognome!:string
    private cf!:string

    setDati(dati:any){
        this.nome=dati.nome
        this.cognome=dati.cognome
        this.cf=dati.cf        
    }

    getNome(){
        return this.nome
    }
    getCognome(){
        return this.cognome
    }
    getCf(){
        return this.cf
    }
    
}